
import ClickOutside from "vue-click-outside";
import { mapState } from "vuex";

export default {
  directives: { ClickOutside },

  props: {
    productImage: { type: Object, default: () => {} },
    selectedOptions: { type: Object, default: () => {} },
  },

  data: () => ({
    showSummary: false,
    showMobileMenu: false,
    showShareOptions: false,
    icons: ["Reset", "Share", "Print"],
  }),

  computed: {
    ...mapState("bedbuilder", ["isGeneratingPDF"]),
    isDefaultOptionsChanged() {
      return Object.entries(this.$bedbuilder.defaultOptions).some(
        ([key, defaultValue]) => {
          return this.$route.query[key] !== defaultValue;
        }
      );
    },
  },

  methods: {
    handleMenuOuterClick() {
      this.showMobileMenu = false;
    },
    handleShareOuterClick() {
      this.showShareOptions = false;
    },
    handleClick(iconName) {
      if (iconName == "reset" && this.isDefaultOptionsChanged) {
        this.$store.dispatch("bedbuilder/openBedbuilderReset");
      } else if (iconName === "Summary") {
        this.showSummary = true;
      } else if (iconName == "print") {
        this.$refs.bedbuilderPrint.printPreview();
      } else if (iconName == "share") {
        this.showShareOptions = true;
      }
      this.showMobileMenu = false;
    },
  },
};
